import { API } from './axios';

export const getSchedulingPage = async slug => {
  const { data } = await API.get(`/${slug}`);
  return data;
};

export const getAvailability = async ({ slug, from, to, duration }) => {
  const { data } = await API.get(`/${slug}/availability`, {
    params: { from, to, duration },
  });
  return data;
};

export const bookSlot = async ({
  slug,
  slot,
  duration,
  name,
  phone,
  email,
}) => {
  const { data } = await API.post(`/${slug}/book`, {
    slot,
    duration,
    name,
    phone,
    email,
  });
  return data;
};
